(function() {
    window.addEventListener("abra:cart:changed", function() {
        document.dispatchEvent(new CustomEvent('theme:update:cart'));
    });
    
    const originalPerformanceObserver = window.PerformanceObserver;
    let lastRerunTime = 0;
    const MIN_RERUN_INTERVAL = 500;

    window.PerformanceObserver = function(callback) {
        const throttledCallback = function(list, observer) {
            const now = Date.now();
            const timeSinceLastRerun = now - lastRerunTime;
            
            if (timeSinceLastRerun < MIN_RERUN_INTERVAL) {
                return;
            }
            
            lastRerunTime = now;
            callback.call(this, list, observer);
        };

        return new originalPerformanceObserver(throttledCallback);
    };

    window.PerformanceObserver.supportedEntryTypes = originalPerformanceObserver.supportedEntryTypes;

    document.addEventListener('theme:cart:change', async function() {
        if (window.Abra && window.Abra.render) {
            await window.Abra.render();
        }
    });
})();